import Model from './Model'
import ViewController from './ViewController'

import updateCriteriaArrayOnAll from './logic/updateCriteriaArrayOnAll'
import updateCriteriaArray from './logic/updateCriteriaArray'

import getInitialValues from './mapSetup/getInitialValues'

import { categories } from './config/config'

const Controller = {
  // setup application
  init(map, data) {
    this.map = map
    this.data = data

    const defaultState = getInitialValues(categories)

    // get state from hash or buttons
    const criteria = Model.getState() || defaultState

    // set start data
    Model.setState(criteria)

    // first draw of map
    ViewController.init(map, data, criteria)

    window.onhashchange = () => this.onHashChange()
  },
  getState() {
    return Model.getState()
  },
  setState(criteria) {
    Model.setState(criteria)
  },
  onHashChange() {
    // do not change any state, just render current state
    const criteria = this.getState() || []
    this.render(criteria)
  },
  onFilterClick(event) {
    event.stopPropagation()

    // change state and render it out
    const siblings = [...event.target.parentNode.childNodes]

    // handle data
    let criteria = this.getState() || []
    const value = event.target.dataset.value

    if (event.target === siblings[0]) {
      criteria = updateCriteriaArrayOnAll(value, criteria)
    } else {
      criteria = updateCriteriaArray(value, criteria)
    }

    // update hash to reflect new app-state
    this.setState(criteria)

    this.render(criteria)
  },
  render(criteria) {
    // draw map from state
    ViewController.renderMap(this.map, this.data, criteria)

    // draw buttons from state
    ViewController.renderControlsState(criteria)
  }
}

export default Controller



// WEBPACK FOOTER //
// ./src/Controller.js